var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:[
    _vm.$options.getClassMap(_vm.props),
    _vm.data.class,
    _vm.data.staticClass
]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }